export function validateScaExperienceMode(scaExperienceMode) {
    return scaExperienceMode === 'modal' || scaExperienceMode === 'iframe'
        ? scaExperienceMode
        : undefined;
}
export function parseRedirectMechanism(scaExperienceMode) {
    const validatedMode = validateScaExperienceMode(scaExperienceMode);
    return validatedMode ? 'iframe' : undefined;
}
